import { createFileRoute, redirect } from '@tanstack/react-router';

/** «Настройки» в меню ведут в первый раздел. */
export const Route = createFileRoute('/_app/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/notifications', replace: true });
  },
});
